import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MemberListComponent } from './member-list/member-list.component';
import { MemberService } from './services/member.service';
import { MemberEditComponent } from './member-edit/member-edit.component';
import { MembersForVerificationComponent } from './members-for-verification/members-for-verification.component';
import { VerificationCodesComponent } from './verification-codes/verification-codes.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { NewIdNotificationModalDialogComponent } from './new-id-notification-modal-dialog/new-id-notification-modal-dialog.component';
import { CancelSubscriptionModalDialogComponent } from './cancel-subscription-modal-dialog/cancel-subscription-modal-dialog.component';
import { WebProfileModalDialogComponent } from './web-profile-modal-dialog/web-profile-modal-dialog.component';
import { AbTestsModalDialogComponent } from "./ab-tests-modal-dialog/ab-tests-modal-dialog.component";
import { MemberDeleteDialogComponent } from "./member-delete-dialog/member-delete-dialog.component";

@NgModule({
  imports: [CommonModule, CoreModule, FormsModule, NgbModule, RouterModule],
  exports: [MemberListComponent, MemberEditComponent],
  providers: [MemberService],
  declarations: [MemberListComponent, MemberEditComponent, MembersForVerificationComponent, VerificationCodesComponent, NewIdNotificationModalDialogComponent, CancelSubscriptionModalDialogComponent, WebProfileModalDialogComponent, AbTestsModalDialogComponent, MemberDeleteDialogComponent],
})
export class MemberModule { }



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/member/member.module.ts